// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8d57436","455":"3218701f"}[chunkId] + ".chunk.js";
};